import { render, staticRenderFns } from "./MerchantLogin.vue?vue&type=template&id=130ed001&"
import script from "./MerchantLogin.vue?vue&type=script&lang=js&"
export * from "./MerchantLogin.vue?vue&type=script&lang=js&"
import style0 from "./MerchantLogin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports